import { type FC } from 'react';
import {
  PackBattleColumn,
  PackBattleCopy,
  PackBattleHeadline,
  PackBattleRow,
  PackBattleAvatar,
  PackBattleSubline,
  PackBattleTitle,
  PackBattleWrapper,
} from './styled';
import { type PackBattleProps } from './types';

const PackBattle: FC<PackBattleProps> = ({
  copy,
  prize,
  avatar,
  counter,
  leader = 'No leader yet',
  highscore = 'No highscore yet',
  ended,
}) => {
  let headline;
  if (ended) {
    headline = counter && counter > 1 ? 'Winners:' : 'Winner:';
  } else {
    headline = counter && counter > 1 ? 'Current leaders:' : 'Current leader:';
  }

  const media = avatar || {
    type: 'image',
    state: 'processed',
    sizes: [{
      width: 220,
      height: 220,
      // eslint-disable-next-line max-len
      url: 'https://firebasestorage.googleapis.com/v0/b/starly-dev.appspot.com/o/assets%2Favatars%2Fic-starly-holo%403x.png?alt=media&token=dbb809a0-badb-4191-8f92-3d18ab6ab43a',
    }],
  };

  return (
    <PackBattleWrapper data-test-id="pack_battle_wrapper">
      <PackBattleTitle data-test-id="pack_battle_title">
        Pack Battle
      </PackBattleTitle>
      <PackBattleRow data-test-id="pack_battle_row">
        <PackBattleColumn data-test-id="pack_battle_column_1">
          <PackBattleHeadline data-test-id="pack_battle_headline_1.1">
            {prize}
          </PackBattleHeadline>
          <PackBattleCopy data-test-id="pack_battle_copy">
            {copy}
          </PackBattleCopy>
        </PackBattleColumn>
        <PackBattleColumn data-test-id="pack_battle_column_2" $grid>
          <PackBattleAvatar data-test-id="pack_battle_avatar" media={media} $counter={counter} />
          <PackBattleHeadline data-test-id="pack_battle_headline_2.1">
            {headline}
          </PackBattleHeadline>
          <PackBattleSubline data-test-id="pack_battle_subline_2.1">
            {leader || 'No leader yet'}
          </PackBattleSubline>
          <PackBattleHeadline data-test-id="pack_battle_headline_2.2">
            {ended ? 'Highscore:' : 'Current highscore:'}
          </PackBattleHeadline>
          <PackBattleSubline data-test-id="pack_battle_subline_2.2">
            {highscore || 'No highscore yet'}
          </PackBattleSubline>
        </PackBattleColumn>
      </PackBattleRow>
    </PackBattleWrapper>
  );
};

export default PackBattle;
